import { z } from 'zod';

export enum Language {
  DE = 'DE',
  FR = 'FR',
}

export const TranslatedTextSchema = z.object({
  [Language.DE]: z.string().optional(),
  [Language.FR]: z.string().optional(),
});

export type TranslatedText = z.infer<typeof TranslatedTextSchema>;
